import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleConversationWrapper = styled.div`
  border-right: 1px solid ${(props: any) => props.theme.colors.borderColor};
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-right: 12px;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 90vh;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
`

export const StyleSearchConversationWrapper = styled.div`
  width: 100%;
  padding: 20px;
  position: relative;
`
export const StyleSearchInput = styled.input`
  width: 82%;
  outline: none;
  border: none;
  transform: translateX(-20px);
  background-color: ${(props: any) => props.theme.colors.darkBlue};
  border-radius: 10px;
  padding: 12px 10px 12px 38px;
  font-size: 13px;
  color: ${(props: any) => props.theme.colors.placeholder};
  &::placeholder {
    font-size: 13px;
    color: ${(props: any) => props.theme.colors.placeholder};
  }
`
export const StyleSearchIconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 28px;
`

export const StyleConversationListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  @media (max-width: 768px) {
    flex-direction: row;
    overflow-x: scroll;
  }
`

export const StyleConversationList = styled.li<{ active?: boolean }>`
  cursor: pointer;
  position: relative;
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 12px;
  transition: all 300ms linear;
  &:hover {
    background-color: ${(props: any) => props.theme.colors.primaryLight};
  }

  ${({ active, theme }: any) =>
    active &&
    css`
      background-color: ${theme.colors.primaryLight};
    `}

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const StyleLatestMessage = styled.p<{ isNewMessageReceived?: boolean }>`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.grey50};
  margin-top: 0.3rem;
  ${(props: any) =>
    props.isNewMessageReceived &&
    css`
      color: ${props.theme.colors.grey50};
    `}
`

export const TimeStatusWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  right: 10px;
  top: 16px;
`
export const HourAgo = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.greyText300};
`
